import gql from "graphql-tag";
import apolloClient from "../../apollo/apollo";

const state = {
  forms: [],
};

const getters = {
  getAllFormSigns: (state) => state.forms,
};

const mutations = {
  setAllFormSigns(state, formSignsList) {
    state.forms = formSignsList.slice();
  },
};

const actions = {
  async fetchAllFormSigns({ commit }) {
    try {
      const response = await apolloClient.query({
        query: gql`
          query findAllFormSign {
            findAllFormSign {
              id
              name
            }
          }
        `,
        context: {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        },
      });

      if (response.data.findAllFormSign) {
        commit("setAllFormSigns", response.data.findAllFormSign);
      }
    } catch (error) {
      console.error("Failed to fetch form signs:", error.message);
    }
  },
  async editFormSign({ commit }, payload) {
    try {
      const response = await apolloClient.mutate({
        mutation: gql`
          mutation editFormSign($id: Int, $formSignInput: FormSignInput) {
            editFormSign(id: $id, formSignInput: $formSignInput) {
              id
            }
          }
        `,
        variables: {
          id: payload.id,
          formSignInput: payload.payload,
        },
        context: {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        },
      });

      if (response.data.editFormSign.errors) {
        console.error(
          "Failed to edit form sign:",
          response.data.editFormSign.errors
        );
        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.error("Failed to edit  form sign:", error.message);
      return false;
    }
  },
  async createFormSign({ commit }, payload) {
    try {
      const response = await apolloClient.mutate({
        mutation: gql`
          mutation createFormSign($formSignInput: FormSignInput) {
            createFormSign(formSignInput: $formSignInput) {
              id
            }
          }
        `,
        variables: {
          formSignInput: payload,
        },
        context: {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        },
      });

      if (response.data.createFormSign.errors) {
        console.error(
          "Failed to create form sign:",
          response.data.createFormSign.errors
        );
        return false;
      } else {
        return true;
      }

      // commit('setSingleUser', response.data.createUser);
    } catch (error) {
      console.error("Failed to create  form sign:", error.message);
      return false;
    }
  },
  async createPatientFormSigns({ commit }, { patientId, formSignIds }) {
    try {
      const response = await apolloClient.mutate({
        mutation: gql`
          mutation createPatientFormSign(
            $patientId: Int!
            $formSignIds: [Int!]!
          ) {
            createPatientFormSign(
              patientId: $patientId
              formSignIds: $formSignIds
            ) {
              id
              pdfUrl
              formSign {
                id
                name
              }
            }
          }
        `,
        variables: {
          patientId: patientId,
          formSignIds: formSignIds,
        },
        context: {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        },
      });

      if (response.data.createPatientFormSign?.errors) {
        console.error(
          "Failed to create patient form signs:",
          response.data.createPatientFormSign.errors
        );
        return { success: false };
      } else {
        return {
          success: true,
          data: response.data.createPatientFormSign,
        };
      }
    } catch (error) {
      console.error("Failed to create patient form signs:", error.message);
      return { success: false };
    }
  },

  async deletePatientFormSign({ commit }, patientFormSignId) {
    try {
      const response = await apolloClient.mutate({
        mutation: gql`
          mutation deletePatientFormSign($id: Int!) {
            deletePatientFormSign(id: $id)
          }
        `,
        variables: {
          id: patientFormSignId,
        },
        context: {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        },
      });

      if (response.data.deletePatientFormSign === false) {
        console.error("Failed to delete patient form sign");
        return { success: false };
      } else {
        return { success: true };
      }
    } catch (error) {
      console.error("Failed to delete patient form sign:", error.message);
      return { success: false };
    }
  },

  async editPatientFormSign({ commit }, { forms, patientFormSignId }) {
    const myForm = [];
    forms.forEach((item) => {
      item.items.forEach((x) => {
        myForm.push(x);
      });
    });

    try {
      const response = await apolloClient.mutate({
        mutation: gql`
          mutation editPatientFormSign(
            $patientFormSignInput: PatientFormSignInput
          ) {
            editPatientFormSign(patientFormSignInput: $patientFormSignInput) {
              id
              pdfBase64
            }
          }
        `,
        variables: {
          patientFormSignInput: {
            patientFormSignId: patientFormSignId,
            forms: myForm,
          },
        },
        context: {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        },
      });

      if (response.data.editPatientFormSign.errors) {
        console.error(
          "Failed to edit patient form sign:",
          response.data.editPatientFormSign.errors
        );
        return { success: false };
      } else {
        return {
          success: true,
          pdfBase64: response.data.editPatientFormSign.pdfBase64,
        };
      }

      // commit('setSingleUser', response.data.createUser);
    } catch (error) {
      console.error("Failed to create patient form sign:", error.message);
      return { success: false };
    }
  },

  hasOneOfRoles({ commit }, roles) {
    return state.permissions.some((permission) => roles.includes(permission));
  },
  setPermissions({ commit }, permissions) {
    commit("setPermissionsMutation", permissions);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
